import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { SelectOption } from 'types/common'
import { HandleDeliveryFeeSize, PackageSize } from 'types/storeDeliveryFee'
import { SelectBox, TextInput } from 'components/Form'
import { Spacer } from 'components/Utility'
import { DeleteIconButton } from 'components/Button'

type Props = {
  disabledRemoveSize: boolean
  handleDeliveryFeeAmount: (regionIndex: number, sizeIndex: number, event: ChangeEvent<HTMLInputElement>) => void
  PACKAGE_SIZES: PackageSize[]
  regionIndex: number
  removeRegion?: (regionIndex: number) => void
  removeSize: (regionIndex: number, sizeIndex: number) => void
  selectSize: (regionIndex: number, sizeIndex: number, selectedSize: PackageSize) => void
  sizes: HandleDeliveryFeeSize[]
}

const DeliveryFeeBySizeForm: FC<Props> = (props) => {
  const {
    disabledRemoveSize,
    handleDeliveryFeeAmount,
    PACKAGE_SIZES,
    regionIndex,
    removeRegion,
    removeSize,
    selectSize,
    sizes,
  } = props

  return (
    <div className={styles.deliveryFee}>
      <div className={styles.deliveryFee__header}>
        <div className={styles.deliveryFee__header__label}>箱のサイズ</div>
        <Spacer size={8} />
        <div className={styles.deliveryFee__header__label}>常温の配送料（税抜）</div>
      </div>
      <Spacer size={8} />
      {sizes.map((size, sizeIndex) => {
        const packageSizeOptions: SelectOption<PackageSize>[] = PACKAGE_SIZES.reduce(
          (prev: SelectOption<PackageSize>[], PACKAGE_SIZE) => {
            // 追加済みのサイズは除外（ただし、選択中のサイズは選択肢として含める）
            if (sizes.some((_size) => _size.package_size === PACKAGE_SIZE) && size.package_size !== PACKAGE_SIZE)
              return prev
            return [...prev, { label: PACKAGE_SIZE, value: PACKAGE_SIZE }]
          },
          []
        )
        return (
          <React.Fragment key={size.package_size}>
            <div className={styles.deliveryFee__body}>
              <div>
                <SelectBox<PackageSize>
                  options={packageSizeOptions}
                  select={(packageSize) => selectSize(regionIndex, sizeIndex, packageSize)}
                  value={size.package_size}
                />
              </div>
              <Spacer size={8} />
              <div>
                <TextInput
                  disabled={false}
                  onChange={(event) => handleDeliveryFeeAmount(regionIndex, sizeIndex, event)}
                  required={true}
                  size={'small'}
                  type={'tel'}
                  value={size.delivery_fee_amount}
                />
              </div>
              <Spacer size={8} />
              <DeleteIconButton
                disabled={disabledRemoveSize}
                onClick={() => {
                  if (removeRegion) {
                    removeRegion(regionIndex)
                  } else {
                    removeSize(regionIndex, sizeIndex)
                  }
                }}
              />
            </div>
            {sizes.length - 1 !== sizeIndex && <Spacer size={8} />}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default DeliveryFeeBySizeForm
